<template>
  <div class='header'>
    <div class="hamburger-button" :class="{hidden: isHidden}" @click="handleMenu">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <transition name="nav">
      <div class="navigation" v-if="!isHidden" @click="handleMenu">
        <div class="nav-container">
          <transition-group name="navlink" tag="div" @before-enter="beforeEnter" appear>
            <a class="nav-link" v-if="!isHidden" v-for="(content, index) in contents" :href="'#'+content.href" @click="clickNav(content)" :key="content.href" :data-index="index">
              {{content.title}}
            </a>
          </transition-group>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {contents} from '../data/data'
export default {
  name: 'Header',
  data () {
    return {
      isHidden: true,
      contents: contents
    }
  },
  methods: {
    handleMenu () {
      this.isHidden = !this.isHidden
    },
    beforeEnter (el) {
      const delay = el.dataset.index * 50
      setTimeout(() => {
        el.classList.add('displayed')
      }, delay)
    },
    clickNav (content) {
      if (content.href === 'players') {
        this.$store.commit('clicked')
        this.$store.commit('falsenJudges')
      } else if (content.href === 'judges') {
        this.$store.commit('clickedJudges')
        this.$store.commit('falsen')
      } else {
        this.$store.commit('falsen')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/css/base.scss";

.header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
  border-top: 6px solid $blue;
  &:before, &:after {
    content: "";
    display: block;
    position: absolute;
    width: 6px;
    height: 100vh;
    background: linear-gradient(to bottom, $blue 20%, rgba(255, 255, 255, 0) 85%);
  }
  &:before {
    left: 0;
  }
  &:after {
    right: 0;
  }
}

.border-bottom {
  position: absolute;
  top: calc(100vh - 10px);
  left: 0;
  width: 100%;
  height: 5px;
  background-color: $blue;
}

.hamburger-button {
  position: absolute;
  right: 20px;
  top: 20px;
  width: 50px;
  height: 44px;
  z-index: 1001;
  cursor: pointer;
  transition: all .5s;
  transform: scale(0.6) rotate(0deg);
}

.hamburger-button span {
  display: inline-block;
  transition: all .5s;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  width: 100%;
  height: 4px;
  animation-name: hamburger-animation;
  animation-duration: 8s;
  animation-iteration-count: infinite;
  transition: all 0.3s;
}

@keyframes hamburger-animation {
  0% {
    background-color: $white;
  }
  33% {
    background-color: $blue;
  }
  66% {
    background-color: $orange;
  }
  100% {
    background-color: $white;
  }
}

.hamburger-button span:nth-of-type(1) {
  top: 0;
}

.hamburger-button span:nth-of-type(2) {
  top: 20px;
  animation-delay: 0.7s;
}

.hamburger-button span:nth-of-type(3) {
  bottom: 0;
  animation-delay: 1.4s;
}

.hamburger-button:not(.hidden) {
  transform: scale(0.7) rotate(360deg);
}

.hamburger-button:not(.hidden) span {
  animation-name: none;
  background-color: $white;
}

.hamburger-button:not(.hidden) span:nth-of-type(1) {
  transform: translateY(20px) rotate(-45deg);
}

.hamburger-button:not(.hidden) span:nth-of-type(2) {
  opacity: 0;
}

.hamburger-button:not(.hidden) span:nth-of-type(3) {
  transform: translateY(-20px) rotate(45deg);
}

.navigation {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100vh;
  background-color: $blue;
  z-index: 1000;
  opacity: 1;
  transition: 0.5s all;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-link {
  display: block;
  color: $white;
  padding: 10px 30px;
  border-bottom: 1px solid $blue2;
  transition: all 0.5s;
  &:not(.displayed) {
    transform: translateX(100%);
    opacity: 0;
  }
}

.nav-enter, .nav-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue